import React, { Component, Fragment } from "react";
import "containers/Template/Header/Mobile/Mobile_toolbar.css";
import { connect } from "react-redux";
import AxiosConfig from "axiosConfig";
import { FaRegTimesCircle } from "react-icons/fa";
import UploadPhoto from "site_media/images/default-profile-pic-feeds.png";
import AddChild from "site_media/images/add-child-button-mobile.png";
import ProfileInfo from "../../../../components/Spotlight/ProfileInfo";
const baseURL = process.env.REACT_APP_API_ENDPOINT.substring(
  0,
  process.env.REACT_APP_API_ENDPOINT.lastIndexOf("/")).slice(0,-3);

/**
 * @description Creates the a menu toolbar for mobile version
 * @class Mobile_toolbar
 * @extends React.Component
 * @type {Mobile_toolbar}
 * @example <Mobile_toolbar />
 * pre-condition: all the imports
 * post-condition: returns the menu page for mobile version
 * @param null
 * @returns {Mobile_toolbar}
 */

class MobileProfiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserList: false,
    };
  }
  onUpdateUser(email, is_above_eighteen) {
    function updateUserState(prop, response) {
      sessionStorage.setItem("userEmail", email);
      prop.onUpdateUser(is_above_eighteen);
    }

    let form_data = new FormData();
    form_data.append("email", email);

    let prop = this.props;
    return AxiosConfig.post(`account/switch/`, form_data, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
      .then(function (response) {
        updateUserState(prop, response);
      })
      .catch();
  }
  showUser = () => {
    this.setState({ showUserList: !this.state.showUserList });
  };
  render() {
    const { toggleShowUsers, showUsers } = this.props;
    const resultURL = baseURL.replace(/(^\w+:|^)\/\//, '');
    return (
      <div
        className={
          showUsers ? "account-profiles show-profiles" : "account-profiles"
        }
      >
        <a href="javascript:void(0)" onClick={toggleShowUsers}>
          <FaRegTimesCircle size={20} style={{ fill: "#fff" }} />
        </a>
        <div className="mobile-toolbar-menu__content">
          <div className="current-profile">
            <ProfileInfo />
          </div>
          {this.props.otherUsers !== "" ? (
            <Fragment>
              <ul className="list-unstyled assosiated-accounts showUser">
                {this.props.otherUsers.map((elem) => (
                  <li
                    key={elem.email}
                    className=""
                    onClick={this.onUpdateUser.bind(
                      this,
                      elem.email,
                      elem.is_above_eighteen
                    )}
                  >
                    {elem.profile_pic !== "" && elem.profile_pic != null ? (
                      <span
                        className="user-avatar"
                        style={{
                          backgroundImage: elem.profile_pic.includes(resultURL)
                            ? `url(${elem.profile_pic})`
                            : `url(${baseURL}${elem.profile_pic})`,
                        }}
                      />
                    ) : (
                      <span
                        className="user-avatar"
                        style={{ backgroundImage: `url(${UploadPhoto})` }}
                        alt={elem.full_name}
                      />
                    )}
                    <h6>{elem.full_name}</h6>
                  </li>
                ))}
              </ul>
              <div className="hr_vertical"></div>
            </Fragment>
          ) : null}
          {this.props.isAboveEighteen ? (
            <a
              href="/add-child"
              className="add-profile"
            ><img src={AddChild} /> <span>Add a child</span></a>
          ) : null}
        </div>
      </div>
    );
  }
}

export default connect()(MobileProfiles);
